import styles from './index.module.less';

type progress = {
  text?: string;
  percent: number | string;
  width?: number;
};
const ProgressLine = (props: progress) => {
  const { text, percent, width = 320 } = props;

  return (
    <div className={styles.container} style={{ width: `${width + 28}px` }}>
      <div className={styles.progressWrap} style={{ width: `${width}px` }}>
        <div
          className={styles.progressBar}
          style={{ width: `${width * (Number(percent) / 100 || 0)}px` }}
        />
      </div>
      <div className={styles.progressText}>{`${Math.floor(Number(percent)) | 0}%` || text}</div>
    </div>
  );
};

export default ProgressLine;
